<template>
  <div :class="['nav-container', { fix }]">
    <ul class="showker-nav">
      <li
        v-for="(item, index) of tabArray"
        :key="index"
        v-tipnew="{ flag: newTab === index, name: '海报模板菜单'}"
        :class="{ active: currentIndex === index }"
        @click="changeIndex(index)"
      >
        {{ item }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Nav',
  props: {
    tabArray: {
      type: Array,
      default: function() {
        return []
      }
    },
    defaultIndex: {
      type: Number,
      default: 0
    },
    fix: {
      type: Boolean,
      default: false
    },
    newTab: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      currentIndex: this.defaultIndex
    }
  },
  watch: {
    defaultIndex(val) {
      this.currentIndex = val
    }
  },
  methods: {
    changeIndex(index) {
      this.currentIndex = index
      this.$emit('change', index)
    }
  }
}
</script>

<style lang="scss" scoped>
.fix{
  position: fixed;
  top: 60px;
  width: 100%;
  z-index: 999;
}
.nav-container{
  height: 60px;
}
.showker-nav {
  position: fixed;
  left: 252px;
  right: 52px;
  min-width: 960px;
  z-index: 9;
  height: 60px;
  line-height: 60px;
  font-size: 16px;
  color: #333;
  zoom: 1;
  background-color: #ffffff;
  border-bottom: 1px solid #e6ebed;
  li {
    float: left;
    position: relative;
    cursor: pointer;

    &:not(:first-child) {
      margin-left: 40px;
    }
  }
  li:after {
    content: '';
    position: absolute;
    bottom: 0;
    height: 4px;
    left: 0;
    right: 0;
    background: #1261FF;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    transform: scaleX(0);
    transition: transform 0.3s;
  }
  li.active {
    color: #1261FF;
    font-weight: 600;
    &:after {
      transform: scaleX(1);
    }
  }
  li:hover {
    color: #1261FF;
  }
}
</style>
